<template>
  <div>
    <Player />
    <button @click="play">Play</button>
  </div>
</template>

<script>
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { createNamespacedHelpers } from 'vuex'
import Player from '../../components/Player'

const TokenStore = createNamespacedHelpers('TokenStore')
const PlaybackStore = createNamespacedHelpers('PlaybackStore')

@Component({
  methods: {
    ...PlaybackStore.mapActions(['updateCurrentTrack', 'updateDeviceId', 'playSongByURI'])
  },
  computed: {
    ...TokenStore.mapState(['access_token'])
  },
  components: { Player }
})
export default class ChannelMain extends Vue {
  mounted() {
    window.onSpotifyWebPlaybackSDKReady = this.onSpotifyWebPlaybackSDKReady
  }
  onPlayerStateChanged(state) {
    if (state) {
      this.updateCurrentTrack(state.track_window.current_track)
    }
  }

  play(spotifyURI) {
    this.playSongByURI('spotify:track:7IcfEY0IyV4fdALbwJCw3v')
  }

  onSpotifyWebPlaybackSDKReady () {
    const appToken = window.localStorage.getItem('app_token')
    const appTokenJSON = JSON.parse(appToken)
    const token = appTokenJSON.access_token
    const player = new Spotify.Player({
      name: 'Web Playback SDK Quick Start Player',
      getOAuthToken: cb => {
        cb(token)
      }
    })

    // Error handling
    player.addListener('initialization_error', ({ message }) => {
      console.error(message)
    })
    player.addListener('authentication_error', ({ message }) => {
      console.error(message)
    })
    player.addListener('account_error', ({ message }) => {
      console.error(message)
    })
    player.addListener('playback_error', ({ message }) => {
      console.error(message)
    })

    // Playback status updates
    player.addListener('player_state_changed', state => this.onPlayerStateChanged(state))

    // Ready
    player.addListener('ready', ({ device_id }) => {
      this.updateDeviceId(device_id)
      console.log('Ready with Device ID', device_id)
    })

    // Not Ready
    player.addListener('not_ready', ({ device_id }) => {
      console.log('Device ID has gone offline', device_id)
    })

    // Connect to the player!
    player.connect()
  }
}
</script>
